
import { ITab } from '@/types/detailPages'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import ImageSlider from '@/components/explore/ImageSlider.vue'
import ContactPerson from '@/components/explore/ContactPerson.vue'
import SimpleSocialMediaArea from '@/components/detail_pages/SimpleSocialMediaArea.vue'
import MapComponent from './MapComponent.vue'
import { ILocation } from '@/types/projects'
import DecoBar from './deco_bar/DecoBar.vue'
import DecoFooter from './deco_bar/DecoFooter.vue'
import LinkContainer from './links/LinkContainer.vue'
import IndividualColorMixin from './mixins/IndividualColorMixin.vue'
import SvgLinkBtn from './links/SvgLinkBtn.vue'

@Component({
  name: 'TabContainer',
  components: {
    ImageSlider,
    ContactPerson,
    SimpleSocialMediaArea,
    MapComponent,
    DecoBar,
    DecoFooter,
    LinkContainer,
    SvgLinkBtn
  }
})
export default class TabContainer extends Mixins(IndividualColorMixin) {
  @Prop({ default: true }) showNavbar!: boolean
  @Prop({ default: false }) showMap!: boolean
  @Prop() tabs!: ITab[]
  @Prop({ required: false }) projectLocations!: ILocation[]
  @Prop({ default: 800 }) charLimit!: number
  @Prop({ default: true }) showSocialMediaBtns!: boolean
  @Prop() instanceSlug!: string
  @Prop() svgLinkType!: 'result_report' | 'project' | 'project_donate' | null
  @Prop({ default: null }) svgTitle!: string | null

  expanded = false

  setActiveTab (key: string): void {
    this.expanded = false
    this.tabs.forEach(tab => {
      tab.is_active = tab.key === key
    })
  }

  getTrimmedHtmlBefore (htmlText: string, maxlength: number): string {
    if (htmlText.length <= maxlength) {
      this.expanded = true
      return htmlText
    }
    const div = document.createElement('div')
    div.innerHTML = htmlText

    let truncated = ''
    let length = 0

    function traverseNodes(node: Node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.split(' ')
        for (const word of words) {
          if (length + word.length + 1 > maxlength) {
            truncated += '...'
            length = maxlength
            break
          } else {
            truncated += (truncated ? ' ' : '') + word
            length += word.length + 1
          }
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        truncated += `<${(node as Element).tagName.toLowerCase()}>`

        Array.from(node.childNodes).forEach(childNode => {
          if (length < maxlength) {
            traverseNodes(childNode)
          }
        })

        truncated += `</${(node as Element).tagName.toLowerCase()}>`
      }
    }

    Array.from(div.childNodes).forEach(childNode => {
      if (length < maxlength) {
        traverseNodes(childNode)
      }
    })

    return truncated
  }
}
